<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{path:'/dashboard'}">Inicio</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Presupuestos</li>
                        </ol>
                    </nav>
                </div>


                <div class="col-md-2" style="margin-bottom: 20px">
                    <label><strong>Desde</strong></label>
                    <base-input
                            addon-left-icon="ni ni-calendar-grid-58"
                            style="margin-bottom: 0px">
                        <flat-picker slot-scope="{focus, blur}"
                                     @on-open="focus"
                                     @on-close="blur"
                                     :config="configDate"
                                     class="form-control datepicker"
                                     v-model="from">
                        </flat-picker>
                    </base-input>
                </div>

                <div class="col-md-2" style="margin-bottom: 20px">
                    <label><strong>Hasta</strong></label>
                    <base-input
                            addon-left-icon="ni ni-calendar-grid-58"
                            style="margin-bottom: 0px">
                        <flat-picker slot-scope="{focus, blur}"
                                     @on-open="focus"
                                     @on-close="blur"
                                     :config="configDate"
                                     class="form-control datepicker"
                                     v-model="to">
                        </flat-picker>
                    </base-input>
                </div>

                <div class="col-md-2" style="margin-bottom: 20px">
                    <label><strong>Presupuesto</strong></label>
                    <select name="" class="form-control" v-model="budget" @change="loadBudgetDets">
                        <option value="0">Todos</option>
                        <option v-for="budget in budgets" :value=budget.id>{{budget.name}}</option>
                    </select>
                </div>

                <div class="col-md-2" style="margin-bottom: 20px">
                    <label><strong>Tipo</strong></label>
                    <select name="" class="form-control" v-model="type" @change="loadBudgetDets">
                        <option value="-1">Todos</option>
                        <option value="1">Ingresos</option>
                        <option value="0">Salidas</option>
                    </select>
                </div>

                <div class="col-md-2" style="margin-bottom: 20px">
                    <label><strong>Método</strong></label>
                    <select name="" class="form-control" v-model="method" @change="loadBudgetDets">
                        <option value="-1">Todos</option>
                        <option value="cash">Efectivo</option>
                        <option value="bank">Banco</option>
                    </select>
                </div>

                <div class="col-md-2" style="margin-bottom: 20px">
                    <label style="display: block"><strong>&nbsp;</strong></label>
                    <button class="btn btn-primary" style="width: 100%" @click="loadBudgetDets">
                        <i class="fas fa-search"></i> Consultar
                    </button>
                </div>

                <div class="col-12 col-md-2" style="margin-bottom: 20px">
                    <button class="btn btn-success" @click="modalNewBudgetDet = true" style="width: 100%">Nuevo
                        movimiento
                    </button>
                </div>

                <div class="col-md-10 text-right" style="margin-bottom: 20px">
                    Ingresos: <strong class="text-success">{{getTotalIngresos | currency}}</strong><br>
                    Gastos: <strong class="text-danger">{{Math.abs(getTotalGastos) | currency}}</strong><br>
                    Total: <strong>{{getTotal | currency}}</strong>
                </div>

                <div class="col-md-12" style="margin-top: 20px">
                    <div class="card" v-if="budgetDets.length > 0">
                        <div class="table-responsive">
                            <table class="table table-striped text-nowrap" id="table-players">
                                <thead>
                                <tr>
                                    <th>Fecha</th>
                                    <th>Presupuesto</th>
                                    <th>Nota</th>
                                    <th>Valor</th>
                                    <th>Método</th>
                                    <th>Acciones</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="budgetdet in budgetDets">
                                    <td class="align-middle">
                                        {{budgetdet.date | parseDate}}
                                    </td>
                                    <td class="align-middle">
                                        {{budgetdet.budget.name}} - {{budgetdet.concept.name}}
                                    </td>

                                    <td class="align-middle">
                                        {{budgetdet.note}}
                                    </td>
                                    <td align="right" class="align-middle">
                                        <span :class="{ 'text-success': budgetdet.value > 0, 'text-danger': budgetdet.value < 0 }">
                                            {{budgetdet.value | currency}}
                                        </span>
                                    </td>
                                    <td class="align-middle">
                                        <span v-if="budgetdet.payMethod ==='cash'">Efectivo</span>
                                        <span v-if="budgetdet.payMethod ==='bank'">Banco</span>
                                    </td>
                                    <td align="center">
                                        <button class="btn btn-sm btn-danger"
                                                @click="openModalDeleteMovimiento(budgetdet.id)"><i
                                                class="fas fa-times"></i></button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-else>
                        <div class="alert alert-danger" role="alert">
                            No hay movimientos de presupuestos.
                        </div>
                    </div>

                </div>

                <modal :show.sync="modalNewBudgetDet">
                    <template slot="header">
                        <h4 class="modal-title" id="exampleModalLabel">Nuevo movimiento</h4>
                    </template>
                    <div>
                        <div class="row">
                            <div class="col-md-12" style="margin-bottom: 20px">

                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="newBudgetDetType"
                                           id="type-salidas" value="0" v-model="newBudgetDet.type" @change=loadConcepts>
                                    <label class="form-check-label" for="type-salidas">Salidas</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="newBudgetDetType"
                                           id="type-ingresos" value="1" v-model="newBudgetDet.type"
                                           @change=loadConcepts>
                                    <label class="form-check-label" for="type-ingresos">Ingresos</label>
                                </div>
                            </div>


                            <div class="col-md-12" style="margin-bottom: 20px">
                                <label><strong>Presupuesto</strong></label>
                                <select name="" class="form-control" v-model="newBudgetDet.budget" @change=loadConcepts>
                                    <option v-for="budget in budgets" :value=budget.id>{{budget.name}}</option>
                                </select>
                            </div>

                            <div class="col-md-12" style="margin-bottom: 20px">
                                <label><strong>Concepto</strong></label>
                                <select name="" class="form-control" v-model="newBudgetDet.concept">
                                    <option v-for="concept in concepts" :value=concept.id>{{concept.name}}</option>
                                </select>
                            </div>

                            <div class="col-md-12" style="margin-bottom: 20px">
                                <label><strong>Observaciones</strong></label>
                                <input type="text" class="form-control" v-model="newBudgetDet.note">
                            </div>

                            <div class="col-md-12" style="margin-bottom: 20px">
                                <label><strong>Importe</strong></label>
                                <vue-numeric currency="€"
                                             class="form-control"
                                             currency-symbol-position="suffix"
                                             :precision="2"
                                             v-model="newBudgetDet.value"></vue-numeric>
                            </div>

                            <div class="col-md-12" style="margin-bottom: 20px">
                                <label><strong>Método</strong></label>
                                <select class="form-control" v-model="newBudgetDet.method">
                                    <option value="cash">Efectivo</option>
                                    <option value="bank">Banco</option>
                                </select>
                            </div>

                            <div class="col-md-12">
                                <label><strong>Fecha</strong></label>
                                <base-input
                                        addon-left-icon="ni ni-calendar-grid-58"
                                        style="margin-bottom: 0px">
                                    <flat-picker slot-scope="{focus, blur}"
                                                 @on-open="focus"
                                                 @on-close="blur"
                                                 :config="configDate"
                                                 class="form-control datepicker"
                                                 v-model="newBudgetDet.date">
                                    </flat-picker>
                                </base-input>
                            </div>
                        </div>
                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="modalNewBudgetDet = false">Cerrar</base-button>
                        <base-button type="primary" @click="saveNewBudgetDet">Guardar</base-button>
                    </template>
                </modal>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import swal from 'sweetalert2'
    import flatPicker from "vue-flatpickr-component";
    import {Spanish} from 'flatpickr/dist/l10n/es'
    import "flatpickr/dist/flatpickr.css";


    export default {
        data() {
            return {
                budgets: [],
                budgetDets: [""],
                concepts: [],
                from: new Date(new Date().getFullYear(), new Date().getMonth()).toISOString(),
                to: "today",
                budget: "0",
                type: "-1",
                method: "-1",
                modalNewBudgetDet: false,
                newBudgetDet: {
                    type: "0",
                    budget: "1",
                    concept: "0",
                    note: "",
                    value: 0,
                    date: "today",
                    method: 'cash'
                },
                configDate: {
                    allowInput: false,
                    altFormat: 'd-m-Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    locale: Spanish
                },
            };
        },
        components: {flatPicker},
        created() {
            this.loadBudgets();
            this.loadBudgetDets();
            this.loadConcepts();
        },
        methods: {
            loadBudgets() {
                let vm = this;
                axios.get(this.$store.getters.apiUrl + 'budgets', {
                    params: {
                        jwt: vm.$store.getters.jwt
                    }
                }).then(response => {
                    if (response.data.response) {
                        vm.budgets = response.data.result;
                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            },
            loadBudgetDets() {
                let vm = this;
                axios.get(this.$store.getters.apiUrl + 'budgetdets', {
                    params: {
                        from: vm.from,
                        to: vm.to,
                        budget: vm.budget,
                        type: vm.type,
                        payMethod: vm.method,
                        jwt: vm.$store.getters.jwt
                    }
                }).then(response => {
                    if (response.data.response) {
                        vm.budgetDets = response.data.result;
                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            },
            loadConcepts() {
                let vm = this;
                axios.get(this.$store.getters.apiUrl + 'concepts', {
                    params: {
                        type: vm.newBudgetDet.type,
                        budget: vm.newBudgetDet.budget,
                        jwt: vm.$store.getters.jwt
                    }
                }).then(response => {
                    if (response.data.response) {
                        vm.concepts = response.data.result;
                        vm.newBudgetDet.concept = vm.concepts[0]["id"];
                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            },
            saveNewBudgetDet() {
                let vm = this;
                axios.post(this.$store.getters.apiUrl + 'budgetdets', {
                    budgetDet: vm.newBudgetDet,
                    jwt: this.$store.getters.jwt
                }).then(response => {
                    if (response.data.response) {
                        vm.modalNewBudgetDet = false;
                        vm.loadBudgetDets();

                        vm.newBudgetDet = {
                            type: "0",
                            budget: "1",
                            note: "",
                            value: 0,
                            date: "today",
                        }

                        this.loadConcepts();

                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            },
            openModalDeleteMovimiento(idBudgetdet) {
                swal({
                    title: '¿Desea eliminar este movimiento?',
                    text: `Esta operación no se puede deshacer`,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    confirmButtonText: 'Si, borrar movimiento',
                    cancelButtonText: 'Cancelar',
                    buttonsStyling: true
                }).then((result) => {
                    if (result.value) {
                        this.deleteMovimiento(idBudgetdet);
                    }
                });

            },
            deleteMovimiento(idBudgetdet) {
                let vm = this;
                axios.post(this.$store.getters.apiUrl + 'budgetdets/' + idBudgetdet + '/delete', {
                    idBudgetdet: idBudgetdet,
                    jwt: this.$store.getters.jwt
                }).then(response => {
                    if (response.data.response) {
                        vm.loadBudgetDets();
                    } else {
                        swal({
                            title: 'Atención',
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                    }
                }).catch(e => {
                    swal({
                        title: 'Atención',
                        text: e,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                });
            },
        },
        computed: {

            getTotalIngresos() {
                let ingresos = 0;

                this.budgetDets.forEach(function (bd) {
                    if (bd.value >= 0) {
                        ingresos += bd.value;
                    }
                });

                return ingresos;

            },
            getTotalGastos() {
                let gastos = 0;

                this.budgetDets.forEach(function (bd) {
                    if (bd.value < 0) {
                        gastos += bd.value;
                    }
                });

                return gastos;
            },
            getTotal() {
                let total = 0;

                this.budgetDets.forEach(function (bd) {
                    total += bd.value;
                });

                return total;
            }
        }

    };
</script>
<style scoped>

    .container-fluid {
        margin-top: 39px;
    }

    .card {
        background-color: #f7fafc !important;
        box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.30) !important;
        border: 1px solid rgba(0, 0, 0, .05);
        border-radius: .375rem;
    }

    #table-players tbody tr:hover {
        background-color: rgba(62, 92, 75, 0.3);
    }

    #table-players tbody tr:hover #name-player {
        text-decoration: underline;
    }


</style>
